import { render } from "./DirPickDepto.vue?vue&type=template&id=bf3bc624"
import script from "./DirPickDepto.vue?vue&type=script&lang=ts"
export * from "./DirPickDepto.vue?vue&type=script&lang=ts"
script.render = render

export default script